<template>
  <div class="button">
    <md-button :class="dynamicClasses" :md-ripple="ripple" :disabled="disabled">
      <template v-if="loading">
        <nna-spinner />
      </template>
      <template v-else>
        <slot />
      </template>
    </md-button>    
  </div>
</template>
<script>
export default {
  name: 'nna-button',
  data () {
    return {}
  },
  props: {
    type: {
      type: String,
      default: 'raised',
    },
    color: {
      type: String, 
      default: 'primary',
    },
    ripple: {
      type: Boolean, 
      default: false,          
    }, 
    disabled: {
      type: Boolean, 
      default: false,          
    },
    loading: {
      type: Boolean, 
      default: false,          
    },       
  },
  computed: {
    dynamicClasses () {
      return {
        ['']: this.type === 'flat',
        ['md-raised']: this.type === 'raised',
        ['md-dense']: this.type === 'dense',
        ['md-primary']: this.color === 'primary',
        ['md-accent']: this.color === 'accent',
        ['md-light']: this.color === 'light',
        ['md-light border']: this.color === 'light-2',
      }
    }
  }      
}
</script>



// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/Button/Button.vue